export const parseAdvancingMoney = (value: string): server.dto.Money => JSON.parse(value);

// The server sends the provided value back as it was submitted. Money is submitted as the amount, the currency is in the original value
export const getAdvancingProvidedValue = (row: server.dto.AdvancingFormRow) => {
  if (row.formElementType !== "money") return row.providedValue;

  const money: server.dto.Money = { currency: parseAdvancingMoney(row.originalValue).currency, amount: parseFloat(row.providedValue) };
  return JSON.stringify(money);
};

// The server stores a provided empty value as null. The original value is the accepted one, approving writes to it
export const getAdvancingRowValue = (row: server.dto.AdvancingFormRow) =>
  row.formItemPhase === "pending" || row.formItemPhase === "declined" ? getAdvancingProvidedValue(row) ?? "" : row.originalValue;

// The server sends money with its currency, the user only enters the amount
export const toAdvancingInputValue = (type: server.dto.FormElementTypes, serverValue: string) => {
  switch (type) {
    case "money":
      return parseAdvancingMoney(serverValue).amount.toString();
    default:
      return serverValue;
  }
};

// A money amount of 0 means there is no price
export const isEmptyAdvancingValue = (type: server.dto.FormElementTypes, value: string) =>
  !value || (type === "money" && parseFloat(value) === 0);

// Every provided item counts towards the total, but unprovided items only when they are mandatory
export const getAdvancingSessionProgress = (session: server.dto.AdvancingSession) => {
  const total = session.pendingCount + session.declinedCount + session.approvedCount + session.mandatoryUnprovidedCount;
  if (total === 0) return 100;

  return Math.round(session.approvedCount / total * 100);
};
